import * as React from "react";
import { BodyContainer, Tag, ItemWrapper, TextWrapper, Title, Body, Link } from "../../smart/modal/modal-style";
import { NewFeature, NewFeatureTag } from "common/Database";
import Modal from "../../smart/modal/modal";

interface Props {
    updates: ReadonlyArray<NewFeature>;
}

export default class WhatsNewModal extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        return (
            <Modal title="What's New in Glide">
                <BodyContainer>
                    {this.props.updates.map((u, i) => {
                        const { title, body, learnMoreURL, tag } = u;
                        return (
                            <ItemWrapper key={i}>
                                <TextWrapper>
                                    <Title>{title + ". "}</Title>
                                    <Body>{body + ". "}</Body>
                                    {learnMoreURL !== undefined && (
                                        <Link target="_blank" href={learnMoreURL}>
                                            Learn more
                                        </Link>
                                    )}
                                </TextWrapper>
                                <Tag isNew={tag === NewFeatureTag.New}>
                                    {tag === NewFeatureTag.New ? "new" : "update"}
                                </Tag>
                            </ItemWrapper>
                        );
                    })}
                </BodyContainer>
            </Modal>
        );
    }
}
